








































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Message } from 'element-ui';
import { post, get } from '@/unite/api';

@Component({})
export default class Header extends Vue {
  username: any = '';
  isPassword: boolean = false
  loading: boolean = false
  new_password2: string = ''
  rules: any = {
    old_password: [{
          required: true,
          message: '请输入原密码',
          trigger: 'blur'
     }],
    new_password: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
    }],
    // new_password2: [{
    //       required: true,
    //       message: '请输入确认新密码',
    //       trigger: 'blur'
    // }],
  }
  info: any ={
    old_password: '',
    new_password: ''
  }
  created() {
    this.username = sessionStorage.getItem('user_name');
  }
  // 退出登录
  private logout() {
    get('/back/v1/usr/logout', {}).then(d => {
      sessionStorage.removeItem('Finance-Jwt-Token');
      this.$router.push('/login');
      Message({
        message: '退出登录成功',
        type: 'success',
        duration: 5 * 1000
      });
    })
    
  }
  handleClose() {
    this.isPassword = false;
  }
  private modify(){
    this.isPassword = true
  }
  private confirm(){
   if(!this.info.old_password || !this.info.new_password){
    return;
   }
   if(this.info.new_password !== this.new_password2){
     this.$message.warning('两次输入新密码不一致')
    return;
   }
   post('/back/v1/usr/reset', this.info).then(d => {
      this.$message.success('修改密码成功,请重新登录')
      setTimeout(() => {
        this.$router.push('/login');
      }, 2000);
    })
  }
}
